import { AfterViewInit, Component, EventEmitter, Inject, Input, Optional, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { Szme037aResponseCdtmnySyosaiRefInfDto, Szme038aResponse } from 'sg-api';
import { Szme038aResponseCdtmnyMeisaiInfDto } from 'sg-api';
// import { DateDurationPipe } from '../../../../pipes/date-duration.pipe';
import { DateDurationPipe } from '../../../../../sg-kd-shared/pipes/date-duration.pipe';
/**
 * 売掛金詳細（内訳）画面
 * @export
 * @class UrikakekinTeigakuDetailUchiwakeComponent
 * @implements {AfterViewInit}
 */
@Component({
  selector: 'app-urikakekin-teigaku-detail-uchiwake',
  templateUrl: './urikakekin-teigaku-detail-uchiwake.component.html',
  styleUrls: ['./urikakekin-teigaku-detail-uchiwake.component.scss'],
  providers: [DateDurationPipe]
})
export class UrikakekinTeigakuDetailUchiwakeComponent implements AfterViewInit {
  /** 売掛金詳細画面情報 */
  @Input() szme038aResponse: Szme038aResponse;

  @Input() urikakekinInfo: Szme037aResponseCdtmnySyosaiRefInfDto;

  @Input() teigakuDetailUchiwake: Szme038aResponseCdtmnyMeisaiInfDto[];

  @Input() prdClsfyDiv: string; 

  @Output() clickEvent = new EventEmitter();

  /** ResponseCustomize 表示領域 */
  @ViewChild('extension_point', { read: ViewContainerRef })
  extensionPointRef!: ViewContainerRef;

  /** 画面表示項目 */
  displayedColumns: string[] = [
    'itemAname',
    'meisaiInfText01',
    'meisaiInf03',
    'meisaiInf02',
    'meisaiInf01',
  ];

  constructor() {
  }
  // constructor(@Optional() @Inject(EXTENSION_POINT_CONFIG) private config: ExtensionPointConfig) {
  // }

  /**	
   * 動的コンポーネントロード処理の呼び出し	
   * @memberof UrikakekinTeigakuDetailUchiwakeComponent	
   */
  ngAfterViewInit(): void {
    // this.loadDynamicComponent();
  }

  // /**	
  //  * 動的コンポーネントのロード処理	
  //  * @private	
  //  * @memberof UrikakekinTeigakuDetailUchiwakeComponent	
  //  */
  // private loadDynamicComponent() {
  //   if (this.config?.szme038aResponseCustomize) {
  //     // 拡張コンポーネントのViewContainerをクリア	
  //     this.extensionPointRef.clear();
  //     // 動的コンポーネントローダーにて拡張コンポーネントをロード	
  //     const ref = this.extensionPointRef.createComponent(this.config.szme038aResponseCustomize);
  //     // レスポンスを動的コンポーネントのインスタンスに設定	
  //     ref.instance.response = this.szme038aResponse;
  //   }
  // }

}
